/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SurveyInfoDto } from '../../models/survey-info-dto';

export interface SurveyControllerFindInfo$Params {
}

export function surveyControllerFindInfo(http: HttpClient, rootUrl: string, params?: SurveyControllerFindInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<SurveyInfoDto>> {
  const rb = new RequestBuilder(rootUrl, surveyControllerFindInfo.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SurveyInfoDto>;
    })
  );
}

surveyControllerFindInfo.PATH = '/api/survey/info';
